import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['scrollable']
  static values = {
    behavior: { type: String, default: 'auto' }
  }

  scroll() {
    this.#scrollable.scrollTo({ top: 0, behavior: this.behaviorValue })
  }

  get #scrollable() {
    return this.hasScrollableTarget ? this.scrollableTarget : window
  }
}
